<ng-container [formGroup]="form">
  <div class="form-grid">
    <div class="d-flex flex-column gap-2">
      <label class="form-input-label" [for]="'firstName'" i18n>First Name</label>
      <app-text-input
        [error]="form?.controls?.firstName?.invalid && formSubmitted"
        formControlName="firstName"
        controlId="firstName" />
      <app-form-error
        *ngIf="formSubmitted && form?.controls?.firstName?.invalid"
        [errors]="form?.controls?.firstName?.errors" />
    </div>
    <div class="d-flex flex-column gap-2">
      <label class="form-input-label" [for]="'middleName'" i18n>Middle Name</label>
      <app-text-input formControlName="middleName" controlId="middleName" />
      <small *ngIf="!form.controls.middleName.disabled" class="form-input-hint" i18n>Optional</small>
    </div>
    <div class="d-flex flex-column gap-2">
      <label class="form-input-label" [for]="'lastName'" i18n>Last Name</label>
      <app-text-input
        [error]="form?.controls?.lastName?.invalid && formSubmitted"
        formControlName="lastName"
        controlId="lastName" />
      <app-form-error
        *ngIf="formSubmitted && form?.controls?.lastName?.invalid"
        [errors]="form?.controls?.lastName?.errors" />
    </div>
    <div class="d-flex flex-column gap-2">
      <label class="form-input-label" [for]="'preferredName'" i18n>Preferred Name</label>
      <app-text-input formControlName="preferredName" controlId="preferredName" />
      <small class="form-input-hint" i18n>Optional</small>
    </div>
    <div class="d-flex flex-column gap-2">
      <label class="form-input-label" [for]="'dateOfBirth'" i18n>Date of Birth</label>
      <app-datepicker-input
        [error]="form?.controls?.birthDate?.invalid && formSubmitted"
        formControlName="birthDate"
        controlId="birthDate" />
      <app-form-error
        *ngIf="formSubmitted && form?.controls?.birthDate?.invalid"
        [errors]="form?.controls?.birthDate?.errors" />
    </div>
    <div class="d-flex flex-column gap-2">
      <label class="form-input-label" [for]="'socialInsuranceNumber'" i18n>Social Insurance Number</label>
      <app-sin-input
        [error]="form?.controls?.socialInsuranceNumber?.invalid && formSubmitted"
        formControlName="socialInsuranceNumber"
        controlId="socialInsuranceNumber" />
      <app-form-error
        *ngIf="formSubmitted && form?.controls?.socialInsuranceNumber?.invalid"
        [errors]="form?.controls?.socialInsuranceNumber?.errors" />
    </div>
    <div class="d-flex flex-column gap-2">
      <label [for]="'genderId'" class="form-input-label" i18n>Sex at Birth</label>
      <app-dropdown-input
        formControlName="genderId"
        controlId="genderId"
        [dropdowns]="genderDropdowns$ | async"
        [error]="formSubmitted && form.controls.genderId.invalid" />
      <app-form-error
        *ngIf="formSubmitted && form.controls.genderId.invalid"
        [errors]="form.controls.genderId.errors"
        [customErrorMessages]="customErrorMessages.genderId" />
    </div>
    <div class="d-flex flex-column gap-2">
      <label [for]="'pronounId'" class="form-input-label" i18n>Pronouns</label>
      <app-dropdown-input
        formControlName="pronounId"
        controlId="pronounId"
        [clearable]="true"
        [dropdowns]="pronounDropdowns$ | async"
        [error]="formSubmitted && form.controls.pronounId.invalid" />
      <small class="form-input-hint" i18n>Optional</small>
      <app-form-error
        *ngIf="formSubmitted && form.controls.pronounId.invalid"
        [errors]="form.controls.pronounId.errors"
        [customErrorMessages]="customErrorMessages.pronounId" />
    </div>
  </div>
</ng-container>
